var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{
    'branded-fare-card': true,
    'branded-fare-card--selected': _vm.is_selected,
  },attrs:{"role":"button","type":"button"},on:{"click":function($event){return _vm.select_flight_offer()}}},[_c('div',{class:{
      'branded-fare-card__head': true,
      'branded-fare-card__head--selected': _vm.is_selected,
    }},[_c('span',{class:{
        'branded-fare-card__radio': true,
        'branded-fare-card__radio--selected': _vm.is_selected,
      }},[_c('span',{staticClass:"branded-fare-card__radio-dot"})]),_c('span',{staticClass:"branded-fare-card__head__title"},[_c('span',{staticClass:"branded-fare-card__head__title-fare"},[_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.branded_fare))+" ")]),_c('span',{staticClass:"branded-fare-card__head__title-price"},[_vm._v(" "+_vm._s(_vm.formatted_price)+" ")])])]),(_vm.filtered_amenities.length)?_c('div',{class:{
      'branded-fare-card__amenities': true,
      'branded-fare-card__amenities--selected': _vm.is_selected,
    }},[_c('div',{staticClass:"branded-fare-card__amenities-container"},[_c('div',{staticClass:"branded-fare-card__amenities-scroller"},_vm._l((_vm.filtered_amenities),function(amenity){return _c('branded-fare-amenity',{key:`amenity:${amenity.code}:${_vm._uid}`,attrs:{"item":amenity}})}),1)])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }